import React from "react";
import classNames from "classnames";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { Dropdown, Option } from "@campgladiator/cgui-core.atoms.dropdown";
import { FormPart } from "@campgladiator/cgui-core.molecules.form-part";
import { Input } from "@campgladiator/cgui-core.atoms.input";
import {
  SelectTrainerInput,
  SelectTrainerInputProps,
} from "../../../SelectTrainerInput";
import styles from "./CreateMembershipSelectProduct.module.scss";

export type CreateMembershipSelectProductProps = {
  couponOptions: Option[];
  handleSelectCouponOption: (option?: Option) => void;
  handleSelectProductOption: (option?: Option) => void;
  handleSelectScheduleOption: (option?: Option) => void;
  handleTrialDaysInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isScheduleRequired: boolean;
  isScheduleVisible: boolean;
  productOptions: Option[];
  scheduleOptions: Option[];
  schedulesMapUrl: string;
  selectedProductOption: Option;
  selectTrainerInputProps: SelectTrainerInputProps;
  trialDays: number;
};

const CreateMembershipSelectProduct = ({
  handleSelectProductOption,
  productOptions,
  selectTrainerInputProps,
  scheduleOptions,
  handleSelectScheduleOption,
  handleTrialDaysInputChange,
  trialDays,
  couponOptions,
  handleSelectCouponOption,
  selectedProductOption,
  isScheduleRequired,
  isScheduleVisible,
  schedulesMapUrl,
}: CreateMembershipSelectProductProps) => (
  <>
    <div className={styles.inputField}>
      <Paragraph size="small" className={styles.label}>
        Select Product*
      </Paragraph>
      <Dropdown
        options={productOptions}
        disabled={!productOptions?.length}
        onChangeSelectedOption={handleSelectProductOption}
      />
      {!productOptions?.length && (
        <Paragraph
          size="small"
          weight="book"
          className={classNames(styles.disabledLabel, styles.warning)}
        >
          Camper already has all eligible subscriptions.
        </Paragraph>
      )}
    </div>
    {isScheduleVisible && (
      <div className={styles.inputField}>
        <Paragraph size="small" weight="book" className={styles.disabledLabel}>
          <em>
            Click the link below to find a workout for your camper if they do
            not already have one in mind. When you are finished, close the tab
            and return here to select the Trainer and Schedule.
          </em>
        </Paragraph>
        <Paragraph size="small" className={styles.linkButton}>
          <a
            onClick={() => {
              window.open(schedulesMapUrl, "_blank");
            }}
          >
            Find a Workout
          </a>
        </Paragraph>
      </div>
    )}
    <div className={styles.inputField}>
      <SelectTrainerInput {...selectTrainerInputProps} />
    </div>
    <div className={styles.inputField}>
      <Paragraph size="small" className={styles.label}>
        Select Schedule {isScheduleRequired ? "*" : ""}
      </Paragraph>
      <Dropdown
        options={scheduleOptions}
        disabled={!scheduleOptions?.length}
        onChangeSelectedOption={handleSelectScheduleOption}
      />
      {!scheduleOptions?.length && (
        <Paragraph size="small" weight="book" className={styles.disabledLabel}>
          Select a trainer to view schedules.
        </Paragraph>
      )}
    </div>
    <div className={styles.column}>
      <div className={styles.inputField}>
        <FormPart
          forId="trialDays"
          label="Trial Days"
          className={styles.formPart}
        >
          <Input
            id="trialDays"
            type="number"
            name="trialDays"
            value={trialDays}
            onChange={handleTrialDaysInputChange}
          />
        </FormPart>
      </div>
      <div className={styles.inputField}>
        <Paragraph size="small" className={styles.label}>
          Discount Code
        </Paragraph>
        <Dropdown
          options={couponOptions}
          disabled={!couponOptions.length || !selectedProductOption}
          onChangeSelectedOption={handleSelectCouponOption}
        />
      </div>
    </div>
  </>
);

export default CreateMembershipSelectProduct;
